import { useState } from 'react';
import { Alert, Pressable, ScrollView, StyleSheet, Text, View } from 'react-native';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import AuthInput from '../components/AuthInput';
import GradientBackground from '../components/GradientBackground';
import colors from '../theme';
import { RootStackParamList } from '../navigation/RootNavigator';
import { forgotPassword } from '../api/auth';

type Props = NativeStackScreenProps<RootStackParamList, 'ForgotPassword'>;

export default function ForgotPasswordScreen({ navigation }: Props) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!email) {
      Alert.alert('Thiếu email', 'Vui lòng nhập email đã đăng ký.');
      return;
    }

    setLoading(true);
    try {
      await forgotPassword(email.trim());
      navigation.navigate('CheckEmail');
    } catch (error) {
      Alert.alert('Không thể gửi yêu cầu', error instanceof Error ? error.message : 'Vui lòng thử lại.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <View style={styles.screen}>
      <GradientBackground fullHeight />
      <ScrollView contentContainerStyle={styles.container} showsVerticalScrollIndicator={false}>
        <Pressable onPress={() => navigation.goBack()} style={styles.backButton}>
          <Text style={styles.backButtonText}>{'<'}</Text>
        </Pressable>

        <View style={styles.header}>
          <Text style={styles.heading}>Quên mật khẩu</Text>
          <Text style={styles.subheading}>Nhập email để nhận hướng dẫn đặt lại mật khẩu.</Text>
        </View>

        <View style={styles.authBox}>
          <AuthInput label="Email" placeholder="name@example.com" value={email} onChangeText={setEmail} />
          <Pressable style={styles.mainButton} onPress={handleSubmit} disabled={loading}>
            <Text style={styles.mainButtonText}>{loading ? 'Đang gửi...' : 'Gửi yêu cầu'}</Text>
          </Pressable>
        </View>
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: 'rgb(242, 249, 253)',
  },
  container: {
    flexGrow: 1,
    paddingHorizontal: 24,
    paddingTop: 44,
    paddingBottom: 34,
  },
  backButton: {
    width: 38,
    height: 38,
    borderRadius: 14,
    backgroundColor: 'rgba(255,255,255,0.78)',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 24,
  },
  backButtonText: {
    color: colors.textPrimary,
    fontSize: 18,
    fontWeight: '900',
  },
  header: {
    marginBottom: 22,
  },
  heading: {
    color: colors.buttonText,
    fontSize: 24,
    fontWeight: '900',
    lineHeight: 31,
  },
  subheading: {
    color: colors.button,
    fontSize: 14,
    lineHeight: 20,
    marginTop: 8,
    fontWeight: '800',
  },
  authBox: {
    borderRadius: 26,
    backgroundColor: 'rgba(255,255,255,0.92)',
    padding: 18,
  },
  mainButton: {
    backgroundColor: colors.button,
    borderRadius: 18,
    height: 48,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 10,
  },
  mainButtonText: {
    color: colors.buttonText,
    fontWeight: '900',
    fontSize: 14,
  },
});
